module.exports = __webpack_public_path__ + "img/28da022.svg";